(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-locations-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-locations-gallery')) {
    customElements.define('bc-locations-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.photos = [...this.querySelectorAll('[data-bc-photo]')];
        this.media = this.querySelector('.bc-locations__lightbox-media');
        this.caption = this.querySelector('.bc-locations__photo-caption');
        this.photos.forEach((link, index) => link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.trigger = link;
          this.showPhoto(index);
          this.dialog.showModal();
        }));
        this.querySelector('.bc-locations__close').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-bc-previous]').addEventListener('click', () => this.showPhoto(this.index - 1));
        this.querySelector('[data-bc-next]').addEventListener('click', () => this.showPhoto(this.index + 1));
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.trigger?.focus({preventScroll: true}));
      }
      showPhoto(index) {
        this.index = (index + this.photos.length) % this.photos.length;
        const link = this.photos[this.index];
        const photo = new Image();
        photo.src = link.href;
        photo.alt = link.querySelector('img').alt;
        this.media.replaceChildren(photo);
        this.caption.textContent = `${this.index + 1} / ${this.photos.length} · ${photo.alt}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-mm15-extras"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bc-mm15-gallery')) {
    customElements.define('bc-mm15-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.photos = [...this.querySelectorAll('[data-bc-photo]')];
        this.media = this.querySelector('.bc-mm15-gallery__lightbox-media');
        this.caption = this.querySelector('.bc-mm15-gallery__photo-caption');
        this.photos.forEach((link, index) => link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.trigger = link;
          this.showPhoto(index);
          this.dialog.showModal();
        }));
        this.querySelector('.bc-mm15-gallery__close').addEventListener('click', () => this.dialog.close());
        this.querySelector('[data-bc-previous]').addEventListener('click', () => this.showPhoto(this.index - 1));
        this.querySelector('[data-bc-next]').addEventListener('click', () => this.showPhoto(this.index + 1));
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.trigger?.focus({preventScroll: true}));
      }
      showPhoto(index) {
        this.index = (index + this.photos.length) % this.photos.length;
        const link = this.photos[this.index];
        const photo = new Image();
        photo.src = link.href;
        photo.alt = link.querySelector('img').alt;
        this.media.replaceChildren(photo);
        this.caption.textContent = `${this.index + 1} / ${this.photos.length} · ${photo.alt}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-seasonal-promo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function show(dlg) {
      if (dlg.open || typeof dlg.showModal !== 'function') return;
      dlg.showModal();
      dlg.focus({ preventScroll: true });
    }

    function setup(root) {
      var dlg = root.querySelector('dialog[data-bc-promo]');
      if (!dlg || dlg.bcPromoReady || typeof dlg.showModal !== 'function') return;
      dlg.bcPromoReady = true;

      var inEditor = !!(window.Shopify && window.Shopify.designMode);
      var forced = /[?&]promo=show(&|$)/.test(window.location.search);
      var key = 'bc-promo:' + dlg.getAttribute('data-key');
      var days = parseFloat(dlg.getAttribute('data-days')) || 7;
      var delay = (parseFloat(dlg.getAttribute('data-delay')) || 0) * 1000;
      var end = dlg.getAttribute('data-end');

      function remember() {
        if (inEditor || forced) return;
        try { window.localStorage.setItem(key, String(Date.now())); } catch (e) {}
      }

      function closedRecently() {
        try {
          var at = parseInt(window.localStorage.getItem(key), 10);
          return !!at && Date.now() - at < days * 86400000;
        } catch (e) {
          return false;
        }
      }

      function expired() {
        if (!end) return false;
        var last = new Date(end + 'T23:59:59');
        return !isNaN(last.getTime()) && Date.now() > last.getTime();
      }

      dlg.addEventListener('close', remember);
      dlg.addEventListener('click', function (event) {
        if (event.target === dlg || event.target.closest('[data-bc-promo-close]')) {
          dlg.close();
        } else if (event.target.closest('a[href]')) {
          remember();
        }
      });

      if (inEditor || expired()) return;
      if (forced) {
        show(dlg);
        return;
      }
      if (closedRecently()) return;
      window.setTimeout(function () {
        if (!document.querySelector('dialog[open]')) show(dlg);
      }, delay);
    }

    function ready() {
      setup(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ready);
    } else {
      ready();
    }

    document.addEventListener('shopify:section:load', function (event) {
      setup(event.target);
    });
    document.addEventListener('shopify:section:select', function (event) {
      var dlg = event.target.querySelector('dialog[data-bc-promo]');
      if (dlg) show(dlg);
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      var dlg = event.target.querySelector('dialog[data-bc-promo]');
      if (dlg && dlg.open) dlg.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-van-redirect"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-bc-van]');
    if (!section) return;
    const review = section.dataset.designMode === 'true' || new URLSearchParams(window.location.search).get('van_preview') === '1';
    if (review) {
      section.querySelector('[data-bc-van-review]').hidden = false;
      return;
    }
    const destination = new URL(section.querySelector('[data-bc-van-destination]').href);
    if (!['https:', 'http:'].includes(destination.protocol)) return;
    const current = new URL(window.location.href);
    if (destination.origin === current.origin && destination.pathname.replace(/\/$/, '') === current.pathname.replace(/\/$/, '')) return;
    window.location.replace(destination.href);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
